import { useMemo } from 'react';
import { type LucideIcon } from 'lucide-react';
import { SPRINGBOARD_CARDS } from './Springboard.constants';
import type { DashboardSpringboardCard, SpringboardTabLabel } from './Springboard.types';

type SpringboardCardLabels = Omit<DashboardSpringboardCard, 'icon'> & {
  icon: string | LucideIcon;
};

type DefaultSpringboardCard = (typeof SPRINGBOARD_CARDS)[number];

export const useSpringboardCards = <T extends SpringboardCardLabels = DefaultSpringboardCard>(
  tabs: readonly SpringboardTabLabel[],
  baseCards: readonly T[] = SPRINGBOARD_CARDS as unknown as readonly T[],
): T[] =>
  useMemo(
    () =>
      baseCards.map((card) => {
        const tab = tabs.find((item) => item.id === card.id);

        return {
          ...card,
          title: tab?.label ?? card.title,
          description: tab?.subtitle ?? card.description,
        };
      }),
    [baseCards, tabs],
  );
